import {useState} from 'react';
import {
  canShowCalendarPrompt,
  suppressCalendarPrompt,
} from './calendarPromptSuppression';

/**
 * 企業フォロー完了時に「予定を追加しましょう」と促すモーダルの
 * 表示状態と開閉ロジックを管理する。
 *
 * フォローボタンの onFollowSuccess に handleFollowSuccess を渡し、
 * 返却される modalVisible / suppressChecked を FollowCompletionModal に渡す。
 */
export function useCalendarPromptModal() {
  const [modalVisible, setModalVisible] = useState(false);
  const [suppressChecked, setSuppressChecked] = useState(false);

  const handleCalendarClose = () => {
    if (suppressChecked) {
      suppressCalendarPrompt();
    }
    setModalVisible(false);
    setSuppressChecked(false);
  };

  // isScheduleRegistered はスキーマによってフィールド名が異なるため
  // （Recruitment は isCalendarRegistered、RecruitmentDetail は hasAddCalendar）
  // 判定結果を呼び出し側から受け取る。
  const handleFollowSuccess = (isScheduleRegistered: boolean) => {
    if (isScheduleRegistered) {
      return;
    }
    if (!canShowCalendarPrompt()) {
      return;
    }
    setModalVisible(true);
  };

  return {
    modalVisible,
    suppressChecked,
    setSuppressChecked,
    handleCalendarClose,
    handleFollowSuccess,
  };
}
